define('shared/initializer/form/adapters/mixins/StoreCouponCodeIntoState',[
    '../../constants',
    'shared/lib/RSVP',
    'shared/util/dispatchers/FormDataDispatcher',
    'shared/util/state/adapters/order',
    'shared/util/state',
    'shared/util/checkout/coupon'
],
function  (
    constants,
    RSVP,
    FormDataDispatcher,
    orderAdapter,
    state,
    couponUtil
) {
    'use strict';
    function Ctor(){}

    Ctor.prototype.doPageLoad = function(){
        var me = this;

        return RSVP.resolve()
            .then(function(){
                return state.adapters.add(orderAdapter);
            })
            .then(function(){
                var dispatcher = new FormDataDispatcher( me.$form );
                return dispatcher.dispatch({
                    items:
                    {
                        'order.couponCode':
                        {
                            sources:
                            [{
                                retrieve: function(){
                                    return couponUtil.get();
                                },
                                allowUndefined: true
                            }],
                            targets:
                            [{
                                type: 'state'
                            }]
                        }
                    },
                    timeout: 1000 * 60 * 60
                });
            });

    };
    
    return Ctor;
});
